"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsShutterstockEnabled = void 0;

var _reselect = require("reselect");

var getConfiguration = function getConfiguration(state) {
  return state.configuration;
};

var getIsShutterstockEnabled = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('withShutterstock') === true;
});
exports.getIsShutterstockEnabled = getIsShutterstockEnabled;